export const SNACK_BAR_DURATION = 2000;
